"use client"
import Container from "@/components/UI/Containers/Container";
import Card from "@/components/app/testy/Card";
import Image from "next/image";
import {SEOUtil} from "@/utils/SEOUtil";

export default function TestPage() {
    return (
        <>
            <SEOUtil name="Testy" url="/app/testy" description="Rozwiąż testy z języka polskiego, matematyki i angielskiego. Sprawdź swoją wiedzę i przygotuj się do egzaminów!" mainEntityOfPage page />
            <main>
                <div className="relative w-full h-[90vh]">
                    <Image
                        src="/testy/baner.webp"
                        alt="Tło testy"
                        fill
                        priority
                        style={{objectFit: "cover", zIndex: 0}}
                    />
                    <section
                        className='absolute inset-0 text-white5 flex flex-col justify-center items-center w-full h-full overflow-hidden bg-cover bg-no-repeat bg-center select-none'
                        style={{
                            background: "linear-gradient(rgba(34, 34, 34, 0.6), rgba(34, 34, 34, 0.6))",
                            zIndex: 1,
                        }}>
                        <Container className='flex flex-col items-center justify-center max-sm:flex-col gap-10 '>
                            <h1 className='text-white16 font-black mb-12 text-[4.2rem] leading-[1.05] tracking-[-0.5px] fadeIn text-center'>
                                Wybierz przedmiot
                            </h1>
                            <div className="flex max-md:flex-col gap-10 ">
                                <Card href="/app/testy/polish" src="/testy/polski.webp" name="Język Polski" />
                                <Card href="/app/testy/math" src={"/testy/matma.webp"} name="Matematyka" />
                                <Card href="/app/testy/english" src={"/testy/angielski.webp"} name="Język Angielski" />
                            </div>
                        </Container>
                    </section>
                </div>
            </main>
        </>
    )
}